import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageService} from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import {} from '@angular/common/http';
import { ProgressBar } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { dataURItoBlob } from '../../../utils/utils';
import { ActivatedRoute } from '@angular/router';
import { SupervisorApiService } from '../../../../core/api/services';
import { SupervisorHelperService } from '../../../../supervisor/supervisor.helper.service';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-add-attachment-modal',
  templateUrl: './add-attachment-modal.component.html',
  styleUrl: './add-attachment-modal.component.css',
  standalone: false,
})
export class AddAttachmentModalComponent  implements OnInit  {
  
  @Input() showAddAttachments: boolean = false;
  @Input() view: string = "patientInstructions";
  @Input() id: number = 0;
  @Input() patientID: number = 0;
  @Input() targetID: number = 0;
  @Output() close = new EventEmitter<boolean>();

  doShowModal: boolean = false;
  isLoading: boolean = false;
  files: File[] = [];
  totalSize : number = 0;
  totalSizePercent : number = 0;
  index: number | null = null;
  dragAreaClass: string = "dragarea"; 
  blobToSave: Blob | null = null; 
  uploadErrors: number = 0;

  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.addFiles(files);
    }
  }

  constructor(
    private route: ActivatedRoute,
    private supervisorApiService: SupervisorApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService
  ) {}
  
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showAddAttachments']) {
      if (this.showAddAttachments == true){
        this.doShowModal = true;
        this.files = [];
      }
      else{
        this.doShowModal = false;
      }
    }
  }

  onFileChange(event: any) {
    let files: FileList = event.target.files;
    this.addFiles(files);
  }

  addFiles(newfiles: FileList) {
    console.log(newfiles);
    var length = newfiles.length
    if(length > 0){
      for (let i = 0; i < length; i++){
        this.files.push(newfiles[i]);
      }
    }
  }
  
  hideModal(): void {
    this.close.emit();
  }

  removeAddedFile(file: File){
    console.log(file);
    var newFiles = this.files.filter(x => x.name != file.name);
    this.files = newFiles;
  }

  uploadFiles() {
    this.isLoading = true;
    var i = 1;
    if(this.files.length > 0){
      for (let file of this.files){
        this.saveFile(file, i);
        i++;
      }
    }
  }

  saveFile(file: File, i: number){
    if(this.view == "patientInstructionAttachment"){
      this.savePatientInstructionAttachmentFile(file, i);
    }
    else if(this.view == "targetAttachment"){
      this.saveTargetAttachments(file, i);
    }
  }

  savePatientInstructionAttachmentFile(file: File, i: number){
    if (this.patientID > 0 && file && file.size > 0) {
      this.isLoading = true;
      this.supervisorApiService.UploadPatientInstructionsAttachment({
        patientID: this.patientID ,
        body: {
          file: file,
        },
      })
      .subscribe({
        next: (response) => {
          this.patientID = +response;
          this.alertService.success('File ' + file.name + ' saved successfully');
          setTimeout(() => this.isLoading = false, 2000);
          if(this.uploadErrors == 0 && this.files.length <= i){
            this.hideModal();
          }
        },
        error: (error) => {
          this.uploadErrors += 1;
          this.alertService.error('Error saving file: ' + file.name);
          console.log(error);
          setTimeout(() => this.isLoading = false, 2000);
        }
      }); 
    }
  }
  saveTargetAttachments(file: File, i: number){
    if (this.targetID > 0 && file && file.size > 0) {
      this.isLoading = true;
      this.supervisorApiService.UploadTargetAttachment({
        targetID: this.targetID ,
        body: {
          file: file,
        },
      })
      .subscribe({
        next: (response) => {
          this.targetID = +response;
          this.alertService.success('File ' + file.name + ' saved successfully');
          setTimeout(() => this.isLoading = false, 2000);
          if(this.uploadErrors == 0 && this.files.length <= i){
            this.hideModal();
          }
        },
        error: (error) => {
          this.uploadErrors += 1;
          this.alertService.error('Error saving file: ' + file.name);
          console.log(error);
          setTimeout(() => this.isLoading = false, 2000);
        }
      }); 
    }
  }
}
